// https://www.dropbox.com/s/dxngjpp0o4039ja/Gaia-GPS_Branding-Guidelines_R5.pdf
export const CONIFER_1 = '#7BF063';
export const CONIFER_2 = '#4EB236';
export const CONIFER_3 = '#2D5E38';
export const CONIFER_4 = '#274F2D';
export const CONIFER_5 = '#294530';
export const CONIFER = CONIFER_3;

export const SPRING_1 = '#4EB236';
export const SPRING_2 = '#64D44C';
export const SPRING_3 = '#7BF063';
export const SPRING_4 = '#A6FF8D';
export const SPRING_5 = '#D6FFCC';
export const SPRING = SPRING_3;

export const SUMMER_1 = '#BA2D1A';
export const SUMMER_2 = '#CF3A20';
export const SUMMER_3 = '#E34B2A';
export const SUMMER_4 = '#EF8C7B';
export const SUMMER_5 = '#FFF0EE';
export const SUMMER = SUMMER_3;

export const FALL_1 = '#CE5A05';
export const FALL_2 = '#FA961B';
export const FALL_3 = '#FDC279';
export const FALL_4 = '#FFF7EB';
export const FALL_5 = '#FFF7EB';
export const FALL = FALL_2;

export const WINTER_1 = '#097789';
export const WINTER_2 = '#0C88A5';
export const WINTER_3 = '#0B97BA';
export const WINTER_4 = '#68D5DE';
export const WINTER_5 = '#CFFFF8';
export const WINTER = WINTER_3;

export const GRANITE_1 = '#343A3A';
export const GRANITE_2 = '#434848';
export const GRANITE_3 = '#616565';
export const GRANITE_4 = '#7E8282';
export const GRANITE_5 = '#A2A5A5';
export const GRANITE_6 = '#C8CBCB';
export const GRANITE_7 = '#E6E8E8';
export const GRANITE_8 = '#F5F6F6';
export const GRANITE_9 = '#F9FBFB';

export const SNOW_BLIND = '#FFFFFF';
